export default function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2>About me</h2>
        </div>
        <div className="content">
          <p>Hey there 👋</p>
          <p>I'm Kaspar Tiri.</p>
          <p>
            I'm an Estonian entrepreneur based in New York. I love building products, finding creative ways to take them to market, and sharing what I learn along the way.
          </p>
          <p>
            In 2014, I co-founded Ready Player Me, a cross-game avatar platform used by 
            150k+ developers. We raised $72M from a16z, Plural, and many others. In 2025, the company was acquired by Netflix.
          </p>
          <p>
            These days, I build stuff for fun, angel invest, and help founders figure things out.
          </p>
          <p>
            When I'm not working, you'll find me surfing or hiking.
          </p>
        </div>
      </div>
    </section>
  );
}

